import { Box, BoxProps } from '@mui/material';
import { SxProps } from '@mui/system';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { ListPaperColumn } from '../list-item';
import { BoldMatchedText } from '../text';

interface Props extends PropsWithChildren {
  label: string;
  avatar?: ReactNode;
  capitalizeLabel?: boolean;
  sx?: SxProps;
  innerSx?: SxProps;
  'data-testid'?: string;
  'data-testid-inner'?: string;
  reverse?: boolean;
  type?: string;
  wrap?: boolean;
  gap?: BoxProps['gap'];
}

export const BasicColumn: FC<Props> = ({ capitalizeLabel, children, label, gap = 1, type, avatar, innerSx, sx, wrap, reverse, ...props }) => {
  const labelStyles = { textTransform: capitalizeLabel ? 'capitalize' : 'none' } as const;

  const mobileSx = {
    '@media (max-width: 600px)': {
      '& > div': {
        fontSize: '0.875rem',
        minHeight: '1.25em',
      },
    },
  };

  if (avatar) {
    return <Box data-testid={props['data-testid']} sx={{ display: 'flex', gap, ...sx }} alignItems='center'>
      {avatar}
      <ListPaperColumn
        data-testid-inner={props['data-testid-inner']}
        reverse={reverse}
        className={type}
        label={label}
        wrap={wrap}
        sx={{ marginLeft: 0, overflow: 'hidden', '& > label': labelStyles, ...mobileSx, ...innerSx }}
      >
        {children}
      </ListPaperColumn>
    </Box>;
  }

  return <ListPaperColumn
    reverse={reverse}
    className={type}
    wrap={wrap}
    data-testid={props['data-testid']}
    label={label}
    sx={{ overflow: 'hidden', '& > label': labelStyles, ...mobileSx, ...innerSx }}
  >
    {children}
  </ListPaperColumn>;
};

export const BasicColumnHighlightedSearch: FC<Props> = ({ children, label, type, innerSx, sx, wrap, reverse, ...props }) => {
  const isString = typeof children === 'string' || typeof children === 'number';
  return <ListPaperColumn reverse={reverse} className={type} wrap={wrap} data-testid={props['data-testid']} label={label} sx={{ overflow: 'hidden', '& > label': { textTransform: 'capitalize' }, ...innerSx }}>
    {isString ? <BoldMatchedText text={children.toString()} /> : children}
  </ListPaperColumn>;
};
